import * as React from "react";
import { ChatMessageBubble } from "@/components/chat/ChatMessageBubble";
import type { StreamMessage } from "../chat-ui.types";
import type { Evidence } from "@/types/evidences";
import { useCurrentPdf } from "@/modules/chat/hooks/useCurrentPdf";

interface Props {
  message: StreamMessage;
  evidences: Evidence[];
  onArtefactClick?: (artefactId: string) => void;
}

export const UserMessage = React.memo(({ message, evidences, onArtefactClick }: Props) => {
  const { setRightDrawerContent, setActiveTab } = useCurrentPdf();

  const handleImprovePrompt = () => {
    setRightDrawerContent("promptGenerator");
    setActiveTab("improve");
  };

  return (
    <ChatMessageBubble
      message={message}
      evidences={evidences}
      source="qa"
      onArtefactClick={onArtefactClick}
      onImprovePrompt={handleImprovePrompt}
      actions={{
        showImprove: true,
        showAddToLibrary: true,
      }}
    />
  );
});
